import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { TreetopPropertiesProvider } from 'shared/util-common';

import {
  AutoCompleteRequest,
  AutoCompleteResponse,
  PrettifyResult,
  RuleValidationRequest,
  RuleValidationResult,
} from '@treetop/shared/model';

import { LanguageService } from './language-service';

@Injectable({
  providedIn: 'root',
})
export class RuleService {
  private http = inject(HttpClient);
  private languageService = inject(LanguageService);
  private router = inject(Router);

  baseUrl = `${TreetopPropertiesProvider.properties.baseUrl}api`;

  validateRule(rule: string, publishedComponents: boolean): Observable<RuleValidationResult> {
    const langCode = this.languageService.language.state;
    const ruleValidation: RuleValidationRequest = {
      rule: rule,
      publishedComponents: publishedComponents,
      languageCode: langCode,
    };
    return this.http.post<RuleValidationResult>(`${this.baseUrl}/rules/validate`, ruleValidation);
  }

  prettifyRule(rule: string, publishedComponents?: boolean): Observable<PrettifyResult> {
    const langCode = this.languageService.language.state;
    const ruleValidation: RuleValidationRequest = {
      rule: rule,
      publishedComponents: publishedComponents,
      languageCode: langCode,
    };
    return this.http.post<PrettifyResult>(`${this.baseUrl}/rules/prettify`, ruleValidation);
  }

  autocompleteRule(rule: string, cursorPosition: number, publishedComponents: boolean): Observable<AutoCompleteResponse> {
    const langCode = this.languageService.language.state;
    const requestConfig: AutoCompleteRequest = {
      rule: rule,
      cursorPosition: cursorPosition,
      publishedComponents: publishedComponents,
      languageCode: langCode,
    };
    return this.http.post<AutoCompleteResponse>(`${this.baseUrl}/rules/auto-complete`, requestConfig);
  }
}
